import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter} from "react-router-dom";
import RootStack from './components/RootStack';


export default function App() {

    return (
      <div className="App">
        {/*<AuthContext.Provider value={authContext}>*/}
            <BrowserRouter>
                <RootStack />
            </BrowserRouter>
        {/*</AuthContext.Provider>*/}
      </div>
    );
}